import { isDefined } from '@sgme/fp';
import type { PersistedTab, SecondaryPersistedTab } from 'apiConnector/tabs/tabs.model';
import { createSelector } from 'reselect';
import type { AppState } from 'state/state.model';

import type { WorkspaceTab } from '../../tabs/tabs.model';

function select(state: AppState, tabId: string) {
  return state.workspaces.secondaryMarketQuotes[tabId];
}

export function getProductKey(appState: AppState, tabId: string) {
  const secondaryQuoteTab = select(appState, tabId);
  return secondaryQuoteTab?.key;
}

export function getPersistedTabFromSecondaryQuotesWorkspaceTab(appState: AppState, tab: WorkspaceTab): PersistedTab {
  const secondaryQuoteTab = select(appState, tab.id);
  return {
    ...tab,
    tabType: tab.type,
    tabContentType: 'secondary',
    key: secondaryQuoteTab.key,
  } as SecondaryPersistedTab;
}

export function getSecondaryMarketQuoteLoadingStatus(state: AppState, tabId: string) {
  return select(state, tabId)?.initFormStatus;
}

export function getSecondaryMarketQuoteErrorKind(state: AppState, tabId: string) {
  return select(state, tabId)?.errorKind;
}

export function getSecondaryMarketQuoteErrorMessage(state: AppState, tabId: string) {
  return select(state, tabId)?.errorMessage;
}

export const getKeepAliveDlpProductIds = createSelector([(state: AppState) => state.workspaces.tabs], tabEntries => {
  const productIds = Object.values(tabEntries)
    .filter(t => t.type === 'dlpProducts' && isDefined(t.key))
    .map(t => t.key!);
  return new Set(productIds);
});

export const hasOtherTabsAssociatedToSameProductKey = (state: AppState, productKey: string, tabId: string) => {
  return Object.values(state.workspaces.tabs)
    .filter(t => t.key === productKey)
    .some(t => t.id !== tabId);
};
